"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function FilmDevelopmentHighlight() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const imageRef = useRef<HTMLDivElement>(null);
  const [scrollOffset, setScrollOffset] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (!imageRef.current) return;
      const rect = imageRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const elementCenter = rect.top + rect.height / 2;
      const offset = (viewportHeight / 2 - elementCenter) * 0.15;
      setScrollOffset(offset);
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section className="relative overflow-hidden bg-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div ref={imageRef} className="relative h-[400px] md:h-[500px] lg:h-[600px] rounded-lg overflow-hidden shadow-medium">
            <div className="absolute inset-0 bg-cover bg-center transition-transform duration-[var(--duration-slow)] ease-linear" style={{
            backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517061/img/film_production_set.png)",
            transform: `translateY(${scrollOffset}px)`
          }} />
          </div>

          <div ref={contentRef} className={`space-y-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-tight">
              Film Project Development & Packaging
            </h2>

            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
              We specialize in structuring film projects to attract funding and
              industry support. Our systematic approach organizes your creative
              vision professionally, connecting you with essential
              relationships, strategy, and infrastructure at every development
              stage.
            </p>

            <Link to="/FilmDevelopmentPage">
              <Button size="lg" className="transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] hover:scale-105 hover:shadow-medium">
                Explore Film Services
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}